module.exports = __webpack_public_path__ + "img/1785.26d3efa7.gif";